module.exports = __webpack_public_path__ + "static/media/warning-triangle.7136edc3.svg";